export const currencyFormatter = (currency = '', locale = window.navigator.language) => {
  const options = currency
    ? { style: 'currency', currency }
    : {
        style: 'decimal',
        minimumFractionDigits: 2,
      };
  return new Intl.NumberFormat(locale, options);
};
